export default {
  title: '防騙視伏器',
  btn: '瀏覽「防騙視伏器」網站',
  c1: 'one_tc.png',
  c2: 'two_tc.png',
  c3: 'three_tc.png',
  c4:"提提您",
  c5:"閣下將打開手機瀏覽器及「防騙視伏器」的網站",
  c6:"暫不",
  c7:"好的",
  c8:"https://cyberdefender.hk/scameter/",
  c9:"遇上可疑來電，釣魚訊息和懷疑詐騙陷阱？一站式詐騙陷阱搜尋器「防騙視伏器」幫到你！立即搜尋可疑的網址，電話號碼，平台帳戶等，參考舉報和風險記錄，時刻保持警惕！點擊查看詳情和下載",
}
